module.exports = __webpack_public_path__ + "img/influencer.efa023e7.svg";